module.exports = __webpack_public_path__ + "static/media/create-icon.6016e44c.svg";